module.exports = __webpack_public_path__ + "img/8.6d949810.jpg";